import {Component, EventEmitter, Input, Output} from "@angular/core";
import {CoreComponent} from "../core-component/core.component";
import {MenuItem} from "primeng/api";


@Component({
  selector: 'stepper',
  templateUrl: './stepper.component.html',
})
export class StepperComponent extends CoreComponent {

  @Input() steps: MenuItem[] | undefined;
  @Input() activeStep: number | undefined;
  @Input() allowStepClick: boolean = true;
  @Output() onStepChange: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();

  handleStepChange(step: MenuItem) {
    if (!this.allowStepClick) {
      return;
    }
    this.onStepChange.emit(step);
  }

}
